import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import "./App.css";
import SideNavBar from "./components/sidebar";
import AdminLogin from './pages/AdminLogin/index';
import Dashboard from "./pages/dashboard";
import Users from "./pages/users";
import Books from "./pages/books";
import Professions from "./pages/professions";
import AiSettings from "./pages/aiSettings";
import AiUsage from "./pages/aiUsage";
import Drive from "./pages/drive";
import Comments from "./pages/comments";
import Reports from "./pages/reports";
import Feedback from "./pages/feedback";
import Series from './pages/series';
import Genre from "./pages/genre";
import Tags from "./pages/tags";
import Pillars from "./pages/pillars";
import Activity from "./pages/activity";
import Reference from "./pages/recommend";
import BookWithSummary from './pages/summary';
import AddSummaryPage from './pages/summary/addSummaryPage';
import EditSummaryPage from './pages/summary/editSummaryPage';
import HomePageContent from './pages/homePage';
import FavoriteAuthors from './pages/favorieAuthors';
import Collections from './pages/collections';
import { LanguageProvider } from './context/languageContext';
import { PermissionProvider } from './context/permissionContext';
import { ConfirmProvider } from './components/confirmDialog';
import SessionTimeoutPopup from './components/popup/sessionTimeout';
import PicksSections from './pages/picksSections';
import SummarySections from './pages/summarySections';
import EditSummarySection from './pages/summarySections/editSectionPage';
import PicksSectionEditor from './pages/picksSections/editSectionPage';
import CollectionEditor from './pages/collections/editCollectionPage';
import SummarySectionPage from './pages/summarySection';
import Team from './pages/team';
import Employees from './pages/employees';
import Trash from './pages/trash';

import MainPage from './pages/mainPage';
import DeleteAccount from './pages/delete-account/index';
import TermsAndConditions from './pages/termsandconditions/index';
import PrivacyPolicy from './pages/privacypolicy/index';


function App() {
  return (
    <BrowserRouter>
      <SessionTimeoutPopup />
      <PermissionProvider>
      <LanguageProvider>
        <ConfirmProvider>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          closeOnClick={false}
          theme="light"
        />
        <Routes>
          <Route path='/auth' element={<AdminLogin />} />
          <Route path="/admin" element={<SideNavBar><Dashboard /></SideNavBar>} />
          <Route path="/users" element={<SideNavBar><Users /></SideNavBar>} />
          <Route path="/books" element={<SideNavBar><Books /></SideNavBar>} />
          <Route path="/genre" element={<SideNavBar><Genre /></SideNavBar>} />
          <Route path="/professions" element={<SideNavBar><Professions /></SideNavBar>} />
          <Route path="/ai-settings" element={<SideNavBar><AiSettings /></SideNavBar>} />
          <Route path="/ai-usage" element={<SideNavBar><AiUsage /></SideNavBar>} />
          <Route path="/drive" element={<SideNavBar><Drive /></SideNavBar>} />
          <Route path="/comments" element={<SideNavBar><Comments /></SideNavBar>} />
          <Route path="/reports" element={<SideNavBar><Reports /></SideNavBar>} />
          <Route path="/feedback" element={<SideNavBar><Feedback /></SideNavBar>} />
          <Route path="/tags" element={<SideNavBar><Tags /></SideNavBar>} />
          <Route path="/pillars" element={<SideNavBar><Pillars /></SideNavBar>} />
          <Route path="/activity" element={<SideNavBar><Activity /></SideNavBar>} />
          <Route path="/recommend" element={<SideNavBar><Reference /></SideNavBar>} />
          <Route path="/summary" element={<SideNavBar><BookWithSummary /></SideNavBar>} />
          <Route path="/summary/add" element={<SideNavBar><AddSummaryPage /></SideNavBar>} />
          <Route path="/summary/edit/:summaryId" element={<SideNavBar><EditSummaryPage /></SideNavBar>} />
          <Route path="/home" element={<SideNavBar><HomePageContent /></SideNavBar>} />
          <Route path="/favorite-authors" element={<SideNavBar><FavoriteAuthors /></SideNavBar>} />
          <Route path="/series" element={<SideNavBar><Series /></SideNavBar>} />
          <Route path="/collections" element={<SideNavBar><Collections /></SideNavBar>} />
          <Route path="/collections/new" element={<SideNavBar><CollectionEditor /></SideNavBar>} />
          <Route path="/collections/:collectionId/edit" element={<SideNavBar><CollectionEditor /></SideNavBar>} />
          <Route path="/picks" element={<SideNavBar><PicksSections /></SideNavBar>} />
          <Route path="/picks/new" element={<SideNavBar><PicksSectionEditor /></SideNavBar>} />
          <Route path="/picks/:sectionId/edit" element={<SideNavBar><PicksSectionEditor /></SideNavBar>} />
          <Route path="/summary-sections" element={<SideNavBar><SummarySections /></SideNavBar>} />
          <Route path="/summary-sections/:sectionId/edit" element={<SideNavBar><EditSummarySection /></SideNavBar>} />
          <Route path="/featured-summary" element={<SideNavBar><SummarySectionPage /></SideNavBar>} />
          <Route path="/team" element={<SideNavBar><Team /></SideNavBar>} />
          <Route path="/employees" element={<SideNavBar><Employees /></SideNavBar>} />
          <Route path="/trash" element={<SideNavBar><Trash /></SideNavBar>} />
          <Route path="/" element={<MainPage />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/terms.html" element={<TermsAndConditions />} />
          <Route path="/privacy.html" element={<PrivacyPolicy />} />
        </Routes>
        </ConfirmProvider>
      </LanguageProvider>
      </PermissionProvider>
    </BrowserRouter>
  );
}

export default App;
